import React, { Component } from 'react';
import Toast from 'react-bootstrap/Toast';

import { nice_time_interval } from 'django-rest-react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';


export interface ToastType {
  title: string,
  message: string | React.ReactComponentElement<any>,
  time?: Date,
  generating_object?: string,
}

export interface ToastTypeWithId extends ToastType {
  id: number
}


interface ownProps extends ToastTypeWithId {
  del_toast_action: (id: number) => void,
  title: string,
}


const ToastWithTime = ({ time, message, title, id, del_toast_action }: ownProps) => {
  const last = time || new Date()

  const [start, setStart] = useState(Math.round(((new Date()).getTime() - last.getTime()) / 1000));
  const timer = useRef<null | number>(null);

  useEffect(() => {
    timer.current = window.setInterval(() => setStart(val => val + 1), 1000);

    return () => {
      if (!!timer.current) {
        clearInterval(timer.current);
      }
    }
  }, [setStart])


  return (
    <Toast
      onClose={() => del_toast_action(id)}
    >
      <Toast.Header>
        <strong className="mr-3">{title}</strong>
        <small>{nice_time_interval(start)}</small>
      </Toast.Header>
      <Toast.Body>{message}</Toast.Body>
    </Toast>
  );
}

export default ToastWithTime;
